import { AssetsAPI } from './AssetsAPI';
import { apiConfig } from '../../../utils/apiConfig';

export function useAssetsAPI(): AssetsAPI {
  return new AssetsAPI(apiConfig);
}
